<template>
  <div class="con-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <!-- SETA OS ANIVERSARIANTES DO DIA -->
      <App-Contato-Aniversariantes :data-time='time' v-if="cpntMostrarAniv === true && $route.name !== 'contato_exc'"></App-Contato-Aniversariantes>

      <!-- SETA O FILTROS E O BOTÃO NOVO CONTATO -->
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="conGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="conGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="conGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='conGerTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="tabper !== '' && $route.name !== 'contato_exc'">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='botao.texto'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>

            <App-Button :data-time="time" v-if="[ '', null, undefined ].indexOf(cpntSelecionar) !== -1 && acessos.vinculo === true"
              :cpntId='vinculo.id'
              :cpntStatus='vinculo.status' 
              :cpntIcone='vinculo.icone'
              :cpntTexto='vinculo.texto'
              :cpntClass='vinculo.class'
              :cpntDisabled="vinculo.disabled"
              @onClick='vinculo.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntFiltros="$refs.filtros"
        :cpntSetarFiltros="conGerTabSetarFiltros"
        :cpntMontarFiltros="conGerTabMontarFiltros"
        :cpntMontarWhere="conGerTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="[ '', null, undefined ].indexOf(cpntSelecionar) !== -1"
        :cpntBotaoExportar="exportar"
        :cpntBotaoEditar="botaoEditar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntSetarValores="conGerTabSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='conGerTabMarcarCheckbox'
        ref="tabela">
          <!-- COLOCA FRASE SOBRE O TOP DA TABELA -->
          <template slot="cabecalho" v-if="$route.name === 'contato_exc'">
            <div style="color: red; font-weight: bold; text-align: center; font-size: var(--font-base-soma-12);">
              Os registros abaixo estão excluídos / desativados.
            </div>
          </template>

          <!-- BOTAO REATIVAR REGISTRO EXCLUIDO -->
          <template slot="botoes" v-if="[ '', null, undefined ].indexOf(botaoReativar) === -1">
            <App-Button :cpntIcone="'reativar'" :cpntStatus="botaoReativar !== 'carregando' ? '' : 'carregando'" :cpntClass="'btn btn-info btn-sm'" :cpntExplica="{ mensagem: 'Selecione os contatos desejados para serem reativados.' }" @onClick='() => { botaoReativar() }'>
            </App-Button>
          </template>

          <!-- COLUNA NOME -->
          <template v-slot:col_nome="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { conGerTabAbrirCadastro("contato", linha.id) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.pessoa === "j" && linha.empresa !== ""' v-html="' (' + linha.empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.status !== "1" && $route.name !== "contato_exc"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>

          <template v-slot:col_id_cms="{ linha }">
            <template v-if="[ '', null, undefined ].indexOf(linha.id_cms) === -1">
              <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { conGerTabAbrirCadastro("contato", linha.id_cms) }'>
                <!-- COLOCA O NOME DO CONTATO -->
                <span v-html="linha.id_cms_nome"></span>
  
                <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
                <span v-if='linha.id_cms_pessoa === "j" && linha.id_cms_empresa !== ""' v-html="' (' + linha.id_cms_empresa + ')'"></span>
  
                <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                <b v-if='linha.id_cms_status !== "1" && $route.name !== "contato_exc"' v-html="'[Excluído]'"></b>
              </App-Button>
            </template>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_vinculo="{ linha }">
            <template v-if="[ '', null, undefined ].indexOf(linha.abrir_vinculo) === -1">
              <!-- COLOCA O BOTÃO -->
              <App-Button :cpntIcone='linha.abrir_vinculo === false ? "mais" : "menos"' @onClick='() => { linha.abrir_vinculo = !linha.abrir_vinculo }'></App-Button>

              <!-- COLOCA O CONTEUDO -->
              <App-Contato-Vinculo-Tabela v-if="linha.abrir_vinculo === true" :cpntContatoId="Number(linha.id)"></App-Contato-Vinculo-Tabela>
            </template>
          </template>
          
          <!-- COLUNA OPTANTE PELO SIMPLES -->
          <template v-slot:col_pj_sn="{ valor }">
            {{ valor === '1' ? 'Sim' : 'Não' }}
          </template>

          <!-- SETA A COLUNA TELEFONE -->
          <template v-slot:col_telefone="{ linha }">
            <div v-if="linha.pessoa === 'e'">
              <span v-html="linha.tel_cel"></span>
            </div>
            <template v-else>
              <div v-if="[ '', null, undefined ].indexOf(linha.tel_cel) === -1">
                <span v-html="linha.tel_cel"></span><span> (Cel.)</span>
              </div>
              <div v-if="[ '', null, undefined ].indexOf(linha.tel_res) === -1">
                <span v-html="linha.tel_res"></span><span> (Res.)</span>
              </div>
              <div v-if="[ '', null, undefined ].indexOf(linha.tel_com) === -1">
                <span v-html="linha.tel_com"></span><span> (Com.)</span>
              </div>
            </template>
          </template>

          <!-- COLUNA TIPO DE PESSOA -->
          <template v-slot:col_pessoa="{ valor }">
            <template v-if="valor === 'f'">
              P. Física
            </template>
            <template v-else-if="valor === 'j'">
              P. Jurídica
            </template>
            <template v-else-if="valor === 'e'">
              Estrangeiro
            </template>
          </template>

          <!-- COLUNA EMAIL -->
          <template v-slot:email="{ linha, valor, indexCV }">
            <a v-if="[ '', null, undefined ].indexOf(valor) === -1" :href='linha[indexCV + "_link"]' target="_blank" class="btn btn-default bt-link-cadastro" v-html="valor"></a>
          </template>

          <!-- COLUNA SITE -->
          <template v-slot:col_site="{ linha, valor, indexCV }">
            <a v-if="[ '', null, undefined ].indexOf(valor) === -1" :href='linha[indexCV + "_link"]' target="_blank" class="btn btn-default bt-link-cadastro" v-html="valor"></a>
          </template>

          <!-- COLUNA ENDEREÇO -->
          <template v-slot:col_endereco="{ linha }">
            <a v-if="[ '', null, undefined ].indexOf(linha.end) === -1"  class="btn btn-default bt-link-cadastro" target="_blank" :href="'http://maps.google.com.br/maps?q=' + linha.end + ' ' + linha.num + ' ' + linha.cep">
              <span v-html='linha.end'></span>
              <span v-html='" , "'></span>
              <span v-html='linha.num'></span>
              <span v-if="[ '', null, undefined ].indexOf(linha.comp) === -1" v-html='" ( " + linha.comp + ")"'></span>
            </a>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_id_p_pais="{ linha }">
            <template v-if="[ '', null, undefined, 0, '0' ].indexOf(linha.id_p_pais) === -1">
              <img :src="'/img/bandeira/' + linha.id_p_pais_img + '.png'" :title='linha.id_p_pais_xPais'/>
            </template>
            <span v-else style="color: red">ERRO</span>
            <!-- <img :src="'/img/bandeira/' + linha.id_p_pais_img + '.png'"> -->
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.updated_user_usuario + '<br/>' + linha.updated_at_ptbr"></span>
          </template>

          <!-- COLUNA PARA AÇÃO DO PET -->
          <template v-slot:col_acao_pet="{ linha }">
            <App-Button :cpntStatus='linha.botao_pet_cadastrar.status' :cpntTexto='linha.botao_pet_cadastrar.texto' :cpntClass='linha.botao_pet_cadastrar.class' @onClick='() => { linha.botao_pet_cadastrar.onClick(linha) }'>
              <span v-html="linha.botao_pet_cadastrar.texto"></span>
            </App-Button>

            |

            <App-Button :cpntStatus='linha.botao_pet_qtde.status' :cpntTexto='linha.botao_pet_qtde.texto' :cpntClass='linha.botao_pet_qtde.class' @onClick='() => { linha.botao_pet_qtde.onClick(linha) }'>
              <span v-html="linha.botao_pet_qtde.texto"></span>
            </App-Button>
          </template>

          <!-- COLUNA PARA AÇÃO DO VEICULO -->
          <template v-slot:col_acao_vei="{ linha }">
            <App-Button :cpntStatus='linha.botao_vei_cadastrar.status' :cpntTexto='linha.botao_vei_cadastrar.texto' :cpntClass='linha.botao_vei_cadastrar.class' @onClick='() => { linha.botao_vei_cadastrar.onClick(linha) }'>
              <span v-html="linha.botao_vei_cadastrar.texto"></span>
            </App-Button>

            |

            <App-Button :cpntStatus='linha.botao_vei_qtde.status' :cpntTexto='linha.botao_vei_qtde.texto' :cpntClass='linha.botao_vei_qtde.class' @onClick='() => { linha.botao_vei_qtde.onClick(linha) }'>
              <span v-html="linha.botao_vei_qtde.texto"></span>
            </App-Button>
          </template>

          <!-- COLUNA PARA AÇÃO DO CONTATO -->
          <template v-slot:col_acao_con="{ linha }">
            <template v-if="(acessos.pet === false && acessos.veiculo === false) || conGerTabVerificarFornecedorCliente(linha) === 'compra'">
              <App-Button :cpntStatus='linha.botao_con_cadastrar.status' :cpntTexto='linha.botao_con_cadastrar.texto' :cpntClass='linha.botao_con_cadastrar.class' @onClick='() => { linha.botao_con_cadastrar.onClick("acao", linha) }'>
                <span v-html="linha.botao_con_cadastrar.texto"></span>
              </App-Button>

              |
            </template>

            <App-Button :cpntStatus='linha.botao_con_qtde.status' :cpntTexto='linha.botao_con_qtde.texto' :cpntClass='linha.botao_con_qtde.class' @onClick='() => { linha.botao_con_qtde.onClick("qtde", linha) }'>
              <span v-html="linha.botao_con_qtde.texto"></span>
            </App-Button>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view v-if="cpntSelecionar === null" :cpntFecharFormulario="conGerTabFecharFormulario"></router-view>
  </div>
</template>

<style scoped>
.con-ger {
  padding-top: 20px;
}
</style>

<style>
  .con-ger > .cabecalho > table > tr > td.cpnt-filtro-bt-esquerda > div > .botao > button {
    margin: 5px 5px 0px 0px;
    width: 100%;
    max-width: 150px;
  }

  .con-ger > .tabela > table > tbody > tr > td.col_nome > div > span > button {
    text-align: left;
    font-size: inherit !important;
  }
  .con-ger > .tabela > table > tbody > tr > td.col_telefone {
    width: 140px;
    min-width: 140px;
  }

  .con-ger > .tabela > table > tbody > tr > td.col_vinculo {
    padding: 5px 0px;
  }
    .con-ger > .tabela > table > tbody > tr > td.col_vinculo > div > span > button {
      margin: 3px;
      padding: 4px 4px;
    }
      .con-ger > .tabela > table > tbody > tr > td.col_vinculo > div > span > button > span > img {
        width: 15px;
        width: 15px !important;
        height: auto !important;
        opacity: 0.9;
      }

  .con-ger > .tabela > table > tbody > tr > td.col_site > div > span > a,
  .con-ger > .tabela > table > tbody > tr > td.col_email > div > span > a,
  .con-ger > .tabela > table > tbody > tr > td.col_email_ctr > div > span > a,
  .con-ger > .tabela > table > tbody > tr > td.col_endereco > div > span > a {
    text-decoration: none;
  }
  .con-ger > .tabela > table > tbody > tr > td.col_id_p_pais > div > span > img {
    margin-right: 5px;
    width: 22px;
    height: auto;
  }
  .con-ger > .tabela > table > tbody > tr > td.col_acao_pet,
  .con-ger > .tabela > table > tbody > tr > td.col_acao_vei,
  .con-ger > .tabela > table > tbody > tr > td.col_acao_con {
    width: 140px;
    min-width: 140px;
    text-align: right;
  }
    .con-ger > .tabela > table > tbody > tr > td.col_acao_pet > div > span > button:first-child,
    .con-ger > .tabela > table > tbody > tr > td.col_acao_vei > div > span > button:first-child,
    .con-ger > .tabela > table > tbody > tr > td.col_acao_con > div > span > button:first-child {
      min-width: 75px;
    }
    .con-ger > .tabela > table > tbody > tr > td.col_acao_pet > div > span > button:last-child,
    .con-ger > .tabela > table > tbody > tr > td.col_acao_vei > div > span > button:last-child,
    .con-ger > .tabela > table > tbody > tr > td.col_acao_con > div > span > button:last-child {
      min-width: 41px;
    }
</style>

<script>
  export default {
    props: {
      cpntNovoCadastroTpCon: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntMostrarAniv: {
        required: false,
        default: function () {
          return true
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
      'App-Contato-Aniversariantes': () => import('@/components/contato/gerenciar/Contato-Aniversariantes.vue'),
      'App-Contato-Vinculo-Tabela': () => import('@/components/contato/gerenciar/Contato-Vinculo-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        tabper: 'Contato',
        route: '/contato/get',
        method: 'POST',
        botao: {
          status: '',
          texto: 'Novo Contato',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => {
            // INICIA A VARIAVEL
            var nome = ''

            // VERIFICA SE TEM ALGUMA COISA PARA SETAR
            if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1) {  
              if ([ '', null, undefined ].indexOf(this.$refs.filtros.$refs) === -1) {  
                if ([ '', null, undefined ].indexOf(this.$refs.filtros.$refs.coringa) === -1) {
                  nome = this.$refs.filtros.$refs.coringa.value
                }
              }
            }

            // VERIFICA O CAMPO
            switch (this.$route.name) {
              case 'contato_gere':
                this.$router.push({ name: 'contato_form', params: { id: 0, nome: nome, tpCon: this.cpntNovoCadastroTpCon } })
                break
            
              default:
                // SETA OS PARAMETROS QUE SERÁ ENVIADO
                var params = { editar: true, tipo: 'contato', id: 0, nome: nome, tpCon: this.cpntNovoCadastroTpCon }

                // SETA O CALLBACK QUE DEVE EXECUTAR AO FECHAR O FORMULARIO
                params.callback = (atualizar, id, dados) => {
                  if (atualizar === true && [ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
                    this.cpntSelecionar(dados)
                  }
                }

                // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
                this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
                break
            }
          }
        },
        vinculo: {
          status: '',
          texto: 'Criar novo vínculo',
          class: [ 'btn', 'btn-info', 'btn-md' ],
          onClick: () => { this.$router.push({ name: 'contato_vinculo_form', params: { id: 0 } }) }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '0', nome: 'Última Alteração',                chave: 'updated_at',  order: 'desc' },
          { id: '1', nome: 'Código Crescente',                chave: 'id',          order: 'asc'  },
          { id: '4', nome: 'Ordem Alfabética',                chave: 'nome',        order: 'asc'  },
          { id: '3', nome: 'Código Decrescente',              chave: 'id',          order: 'desc' }
        ],  
        where: {},
        field: {},
        fieldVir: [],
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        acessos: {
          veiculo: false,
          pet: false,
          vinculo: false
        },
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        exportar: undefined
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.conGerTabSetarStatusGeral('carregando')

      // INICIA O CARREGAMENTO
      this.conGerTabBuscarLinhas()
    },
    methods: {
      conGerTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.conGerTabBuscarLinhas()
        }
      },
      conGerTabBuscarLinhas: function () {
        // VERIFICA SE TEM ACESSO AO ITEM DESEJADO
        this.acessos.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true
        this.acessos.veiculo = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true
        this.acessos.vinculo = this.$store.state.configuracoes.contato.cfg_vinculo === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 100 ], null, false) === true

        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null
        this.botaoReativar = null
        this.exportar = null

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // VERIFICA SE DEVE SELECIONAR UM ITEM
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) !== -1) {
          // VERIFICA SE ESTÁ PAGINA DEVE APRESENTAR O BOTÃO EXCLUIR
          if (this.$route.name !== 'contato_exc') {
            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 105 ], null, false) === true) {
              this.botaoEditar = this.conGerTabEditar
            }
    
            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 106 ], null, false) === true) {
              this.botaoExcluir = this.conGerTabExcluir
            }

            // SETA O EXPORTAR DA TELA
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 39 ], null, false) === true) {
              this.exportar = {
                format: [ 'xlsx', 'pdf' ],
                search: true,
                // field: [  
                //   { nome:                     'Nome'                    },
                //   { cnpj_cpf:                 'CNPJ/CPF'                },
                //   { pj_sn:                    'Opt. SN'                 },
                //   { ie:                       'IE'                      },
                //   { im:                       'IM'                      },
                //   { rg:                       'RG'                      },
                //   // { pf_est_civil_nome:        'Estado Civil'            }, NÃO EXITE JOIN PARA CONVERTER ESSE VALOR
                //   { pf_nacionalidade:         'Nacionalidade'           },
                //   { tel_cel:                  'Telefone Celular'        },
                //   { tel_com:                  'Telefone Comercial'      },
                //   { tel_res:                  'Telefone Residencial'    },
                //   { pf_empresa:               'Empresa'                 },
                //   { cargo:                    'Cargo'                   },
                //   { pf_profissao:             'Profissão'               },
                //   { contato:                  'Contato'                 },
                //   { email:                    'E-mail'                  },
                //   { email_ctr:                'E-mail para contrato'    },
                //   { site:                     'Web-Site'                },
                //   { cep:                      'CEP'                     },
                //   { end:                      'Enderço'                 },
                //   { num:                      'Numero'                  },
                //   { comp:                     'Complemento'             },

                //   { bairro:                   'Bairro'                  },
                //   { id_cidade_cidade:         'Cidade'                  },
                //   { id_estado:                'UF - Estado'             },
                //   { aniv:                     'Abertura/Aniversário'    },
                //   { obs:                      'Observações'             },
                //   { id_tp_con_nome:           'Tipo Contato'            },
                //   { pessoa:                   'Tipo Pessoa'             },
                //   { updated_user_usuario:     'Alterado por'            },
                //   { updated_at_ptbr:          'Última Alteração'        }
                // ]
              }
            }
          } else {
            // SETA O BOTÃO REATIVAR
            this.botaoReativar = this.conGerTabReativar

            // SETA O WHERE QUE DEVE REALIZAR
            this.where = { aAnd: [ { f: 'status', o: '=', v: '0' } ] }
          }          
        }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,                  chave: 'id',                                               export: { fields: {} }, tipo: 'checkbox' },
          { mPer: 0,                  chave: 'id',                nome: 'Cód.',                  export: { fields: {} } },
          { mPer: 2,                  chave: 'nome',              nome: 'Nome',                  export: { fields: {} } },
          { mPer: 1,                  chave: 'vinculo',           nome: 'Vínculos',              export: { fields: {} } },
          { mPer: 1,                  chave: 'cnpj_cpf',          nome: 'CNPJ/CPF',              export: { fields: {} } },
          { mPer: 0,                  chave: 'pj_sn',             nome: 'Opt. SN',               export: { fields: {} }, explica: { mensagem: 'Optante pelo Simples Nacional' } },
          { mPer: 0,                  chave: 'ie',                nome: 'IE',                    export: { fields: {} }, explica: { mensagem: 'Inscrição Estadual' } },
          { mPer: 0,                  chave: 'im',                nome: 'IM',                    export: { fields: {} }, explica: { mensagem: 'Inscrição Municipal' } },
          { mPer: 0,                  chave: 'rg',                nome: 'RG',                    export: { fields: {} }, explica: { mensagem: 'Registro Geral' } },
          { mPer: 0,                  chave: 'pf_est_civil_nome', nome: 'Estado Civil',          export: { fields: {} } },
          { mPer: 0,                  chave: 'pf_nacionalidade',  nome: 'Nacionalidade',         export: { fields: {} } },
          { mPer: 1,                  chave: 'telefone',          nome: 'Telefones',             export: { fields: { tel_cel: 'Telefone Celular', tel_com: 'Telefone Comercial', tel_res: 'Telefone Residencial' } } },
          { mPer: 0,                  chave: 'pf_empresa',        nome: 'Empresa',               export: { fields: {} } },
          { mPer: 0,                  chave: 'cargo',             nome: 'Cargo',                 export: { fields: {} } },
          { mPer: 0,                  chave: 'pf_profissao',      nome: 'Profissão',             export: { fields: {} } },
          { mPer: 0,                  chave: 'contato',           nome: 'Contato',               export: { fields: {} } },
          { mPer: 0, slot: 'email',   chave: 'email',             nome: 'E-mail',                export: { fields: {} } },
          { mPer: 0, slot: 'email',   chave: 'email_ctr',         nome: 'E-mail para contrato',  export: { fields: {} } },
          { mPer: 0,                  chave: 'site',              nome: 'Web-Site',              export: { fields: {} } },
          { mPer: 0,                  chave: 'cep',               nome: 'CEP',                   export: { fields: {} } },
          { mPer: 0,                  chave: 'endereco',          nome: 'Endereço',              export: { fields: { end: 'Enderço', num: 'Numero', comp: 'Complemento' } } },
          { mPer: 0,                  chave: 'bairro',            nome: 'Bairro',                export: { fields: {} } },
          { mPer: 0,                  chave: 'id_cidade_cidade',  nome: 'Cidade',                export: { fields: {} } },
          { mPer: 0,                  chave: 'id_estado',         nome: 'UF - Estado',           export: { fields: {} } },
          { mPer: 0,                  chave: 'id_p_pais',         nome: 'País',                  export: { fields: { id_p_pais_xPais: 'País Nome' } } },
          { mPer: 0,                  chave: 'aniv',              nome: 'Abertura/Aniversário',  export: { fields: {} } },
          { mPer: 0,                  chave: 'obs',               nome: 'Observações',           export: { fields: {} } },
          { mPer: 1,                  chave: 'id_cms',            nome: 'Vendedor',              export: { fields: { id_cms_nome: 'Vendedor Nome' } } },
          { mPer: 1,                  chave: 'id_tp_con_nome',    nome: 'Tipo Contato',          export: { fields: {} } },
          { mPer: 1,                  chave: 'pessoa',            nome: 'Tipo Pessoa',           export: { fields: {} } },
          { mPer: 1,                  chave: 'last',              nome: 'Última Alteração',      export: { fields: { updated_user_usuario: 'Alterado por', updated_at_ptbr: 'Última Alteração' } } },
          { mPer: 2,                  chave: 'acao_pet',          nome: 'Pet',                   export: { fields: {} } },
          { mPer: 2,                  chave: 'acao_vei',          nome: 'Veículos',              export: { fields: {} } },
          { mPer: 2,                  chave: 'acao_con',          nome: 'Iniciar',               export: { fields: {} } }
        ]

        // INICIA A VARIAVEL
        this.fieldVir = []

        // VERIFICA OS CAMPOS VIRTUAIS QUE DEVE BUSCAR
        if (this.acessos.vinculo === true) {
          this.fieldVir.push('qtde_vinculo')
        }
        if (this.acessos.veiculo === true) {
          this.fieldVir.push('qtde_veiculo')
        }
        if (this.acessos.pet === true) {
          this.fieldVir.push('qtde_pet')
        }
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true) {
          this.fieldVir.push('demanda_venda_total_qtde')
        }
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, null, null, false) === true) {
          this.fieldVir.push('demanda_compra_total_qtde')
        }

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // LIMPA A ORDENAÇÃO DA TABELA
        this.order = {}

        // SETA OS VALORES QUE DEVE BUSCAR NA API
        this.field = {
          id: null,
          nome: null,
          empresa: null,
          status: null,
          updated_at: null,
          cnpj_cpf: null,
          pj_sn: null,
          ie: null,
          im: null,
          rg: null,
          pf_est_civil: null,
          pf_nacionalidade: null,
          tel_res: null,
          tel_com: null,
          tel_cel: null,
          pf_empresa: null,
          cargo: null,
          pf_profissao: null,
          contato: null,
          email: null,
          email_ctr: null,
          site: null,
          id_p_pais: { j: { xPais: null, img: null } },
          cep: null,
          end: null,
          num: null,
          comp: null,
          bairro: null,
          id_cidade: { j: { cidade: null } },
          id_estado: { j: { estado: null } },
          aniv: null,
          obs: null,
          id_tp_con: { j: { nome: null } },
          pessoa: null,
          updated_user: { j: { usuario: null } },
          id_cms: { j: { nome: null, empresa: null, pessoa: null, status: null } }
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO DA TABELA
          this.order = { updated_at: 'desc' }

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          remover = remover.concat([ 'id', 'vinculo', 'id_tp_con_nome', 'last', 'acao_pet', 'acao_vei', 'acao_con' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        } else {
          // VERIFICA SE TEM O PACOTE PARA APRESENTAÇÃO DOS CAMPOS ABAIXO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 22 ], null, null, null, null, null, false) === false) {
            remover = remover.concat([ 'pf_est_civil_nome', 'pf_nacionalidade', 'pf_empresa', 'pf_profissao' ])
          }
  
          // REMOVE A COLUNA DO PET
          if (this.acessos.pet === false) {
            remover.push('acao_pet')
          }
  
          // REMOVE A COLUNA DO VEICULO
          if (this.acessos.veiculo === false) {
            remover.push('acao_vei')
          }
  
          // REMOVE A COLUNA DE EMAIL DE CONTRATO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 26 ], null, null, null, null, null, false) === false) {
            remover.push('email_ctr')
          }
  
          // VERIFICA SE DEVE REMOVER A COLUNA VINCULO
          if (this.acessos.vinculo === false) {
            remover.push('vinculo')
          }
          
          // REMOVE AS COLUNAS QUE NÃO DEVE APRESENTAR
          if (this.$route.name === 'contato_exc') {
            remover = remover.concat([ 'acao_pet', 'acao_vei', 'acao_con' ])
          }
  
          // VERIFICA SE TEM PERMISSÃO PARA TELA DE VENDAS
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === false) {
            remover = remover.concat([ 'acao_con' ])
          }  

          // VERIFICA SE TEM PERMISSÃO PARA TELA DE VENDAS
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === false) {
            remover = remover.concat([ 'id_cms' ])
          }  
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.conGerTabReiniciar()
        } else {
          this.conGerTabSetarStatusGeral('')
        }
      },
      conGerTabBotaoAcao: function (tipo, linha) {
        // PEGA O TIPO DO CONTATO
        var acao = this.conGerTabVerificarFornecedorCliente(linha)

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (acao + '--' + tipo) {
          case 'venda--acao':
            this.$router.push({ name: 'venda_nova_id', params: { id: linha.id, tipo: 'contato' } })
            break

          case 'venda--qtde':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'venda_busc', params: { cts: this.$store.state.token.cts, busca: window.btoa(JSON.stringify({ f: 'id_con_nome', o: '=', v: linha.id })) } }).href, '_blank')
            break

          case 'compra--acao':
            this.$router.push({ name: 'compra_nova_id', params: { id: linha.id, tipo: 'contato' } })
            break

          case 'compra--qtde':
            this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/compras/compras.php?cts=' + this.$store.state.token.cts + '&f=' + window.btoa(linha.nome), '_blank')
            break
        }
      },
      conGerTabAbrirCadastro: function (tipo, id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id: id }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.conGerTabBuscarLinhas()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      conGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'nome':
            if (where.o === '=') {
              retorno.where = { f: 'id', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { f: 'nome' })
            }
            break

          case 'id_cms_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_cms', o: 'in', v: where.v.join() }
            } else {
              retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
                model: "cms_cfg_com",
                where: {
                  aAnd: [
                    { f: 'status', o: '=', v: '1' },
                    { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                      model: "contato",
                      where: { aAnd: [ Object.assign(where, { f: 'nome' }) ] }
                    } }
                  ]
                }
              } }
            }
            break

          case 'cnpj':
          case 'cpf':
            retorno.where = { f: 'cnpj_cpf', o: where.o, v: where.v }
            break        

          case 'id_cms_cnpj':
          case 'id_cms_cpf':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'cnpj_cpf', o: where.o, v: where.v } ] }
                  } }
                ]
              }
            } }
            break

          case 'telefone':
            retorno.where = { aOr: [
              { f: 'tel_res', o: where.o, v: where.v },
              { f: 'tel_com', o: where.o, v: where.v },
              { f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break

          case 'id_cms_telefone':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { aOr: [
                    { f: 'tel_res', o: where.o, v: where.v },
                    { f: 'tel_com', o: where.o, v: where.v },
                    { f: 'tel_cel', o: where.o, v: where.v }
                  ] }
                ]
              }
            } }
            break

          case 'email':
            retorno.where = { f: 'email', o: where.o, v: where.v }
            break

          case 'id_cms_email':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'email', o: where.o, v: where.v } ] }
                  } }
                ]
              }
            } }
            break

          case 'estado':
            retorno.where = { f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_cms_estado':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'id_estado', o: where.o, v: where.v.join(',') } ] }
                  } }
                ]
              }
            } }
            break

          case 'cidade':
            retorno.where = { f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_cms_cidade':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'id_cidade', o: where.o, v: where.v.join(',') } ] }
                  } }
                ]
              }
            } }
            break

          case 'tp_con':
            retorno.where = { f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_cms_tp_con':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'id_tp_con', o: where.o, v: where.v.join(',') } ] }
                  } }
                ]
              }
            } }
            break

          case 'pessoa':
            retorno.where = { f: 'pessoa', o: where.o, v: where.v }
            break

          case 'id_cms_pessoa':
            retorno.where = { f: "id_cms", o: "in", r: "id_con", q: {
              model: "cms_cfg_com",
              where: {
                aAnd: [
                  { f: 'status', o: '=', v: '1' },
                  { m: "cms_cfg_com", f: "id_con", o: "in", r: "id", q: {
                    model: "contato",
                    where: { aAnd: [ { f: 'pessoa', o: where.o, v: where.v } ] }
                  } }
                ]
              }
            } }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { o: 's.ft', v: where.v }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      conGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.conGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      conGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.conGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      conGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.conGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      formataTelefone: function (value) {
        // REMOVE TUDO QUE NÃO FOR NUMERO
				value = value.replace(/\D/g, '')
        
        // VERIFICA SE TEM DDI INFORMADO
        if (value.length === 8 || value.length === 9) {
          value = '00' + value
        }

        // COLOCA UM PARENTESES NOS DOIS PRIMEIROS DIGITOS
				value = value.replace(/^(\d\d)(\d)/g,"($1) $2");

        // VERIFICA A MASCARA QUE DEVE FAZER				
				return (value.length < 14 ? value.replace(/(\d{4})(\d)/,"$1-$2") : value.replace(/(\d{5})(\d)/,"$1-$2"))
			},
      conGerTabSetarLinhas: function (vetor) {
        // INICIA A VARIAVEL VETOR
        var results = {}

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_FORMATAR_TELEFONE = require('@/assets/js/Funcoes-Gerais.js').FUN_FORMATAR_TELEFONE

        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // VERIFICA SE TEM VALOR A SER PROCURADO
          if ([ '', null, undefined ].indexOf(vetor[index].pf_est_civil) === -1) {
            // PROCURA O VALOR SOLICITADO
            results = this.$store.state.estadoCivil.filter(item => item.id === vetor[index].pf_est_civil)

            // PEGA O NOME DO CAMPO
            vetor[index].pf_est_civil_nome = results.length >= 1 ? results[0].nome : ''
          }

          // VERIFICA SE TEM VINCULO ENTRE CONTATOS
          vetor[index].abrir_vinculo = ''
          if ([ '', null, undefined, '0' ].indexOf(vetor[index].virtual_qtde_vinculo) === -1 && Number(vetor[index].virtual_qtde_vinculo) >= 1) {
            vetor[index].abrir_vinculo = false
          }

          // FORMATA OS TELEFONES
          if (vetor[index].pessoa !== 'e') {
            if ([ '', null, undefined ].indexOf(vetor[index].tel_cel) === -1) {
              vetor[index].tel_cel = FUN_FORMATAR_TELEFONE(vetor[index].tel_cel)
            }
            if ([ '', null, undefined ].indexOf(vetor[index].tel_com) === -1) {
              vetor[index].tel_com = FUN_FORMATAR_TELEFONE(vetor[index].tel_com)
            }
            if ([ '', null, undefined ].indexOf(vetor[index].tel_res) === -1) {
              vetor[index].tel_res = FUN_FORMATAR_TELEFONE(vetor[index].tel_res)
            }
          }

          // VERIFICA SE TEM TODOS OS PARAMETROS DO LINK
          vetor[index].site_link = vetor[index].site
          if ([ '', null, undefined ].indexOf(vetor[index].site) === -1 && vetor[index].site.indexOf('http') === -1) {
            vetor[index].site_link = 'http://' + vetor[index].site
          }
          vetor[index].email_link = vetor[index].email
          if ([ '', null, undefined ].indexOf(vetor[index].email) === -1 && vetor[index].email.indexOf('mailto') === -1) {
            vetor[index].email_link = 'mailto:' + vetor[index].email
          }
          vetor[index].email_ctr_link = vetor[index].email_ctr
          if ([ '', null, undefined ].indexOf(vetor[index].email_ctr) === -1 && vetor[index].email_ctr.indexOf('mailto') === -1) {
            vetor[index].email_ctr_link = 'mailto:' + vetor[index].email_ctr
          }

          // SETA OS BOTÕES PARA COLUNA PET
          vetor[index].botao_pet_cadastrar = {
            status: '',
            texto: 'Cadastrar',
            class: [ 'btn', 'btn-info', 'btn-sm' ],
            mostrar: true,
            onClick: (linha) => { this.$router.push({ name: 'pet_form', params: { id: 0, id_con: linha.id, id_con_nome: linha.nome, busca: window.btoa(JSON.stringify({ f: 'id_con_nome', o: '=', v: linha.id })) } }) }
          }
          vetor[index].botao_pet_qtde = {
            status: '',
            texto: ([ '', null, undefined ].indexOf(vetor[index].virtual_qtde_pet) !== -1 ? 0 : vetor[index].virtual_qtde_pet).toString(),
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: true,
            onClick: (linha) => { this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'pet_busc', params: { cts: this.$store.state.token.cts, busca: window.btoa(JSON.stringify({ f: 'id_con_nome', o: '=', v: linha.id })) } }).href, '_blank') }
          }

          // SETA OS BOTÕES PARA COLUNA VEICULO
          vetor[index].botao_vei_cadastrar = {
            status: '',
            texto: 'Cadastrar',
            class: [ 'btn', 'btn-info', 'btn-sm' ],
            mostrar: true,
            onClick: (linha) => { this.$router.push({ name: 'veiculo_form', params: { id: 0, id_con: linha.id, id_con_nome: linha.nome, busca: window.btoa(JSON.stringify({ f: 'id_con_nome', o: '=', v: linha.id })) } }) }
          }
          vetor[index].botao_vei_qtde = {
            status: '',
            tipo: 'texto',
            texto: ([ '', null, undefined ].indexOf(vetor[index].virtual_qtde_veiculo) !== -1 ? 0 : vetor[index].virtual_qtde_veiculo).toString(),
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: true,
            onClick: (linha) => { this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'veiculo_busc', params: { cts: this.$store.state.token.cts, busca: window.btoa(JSON.stringify({ f: 'id_con_nome', o: '=', v: linha.id })) } }).href, '_blank') }
          }

          // SETA OS BOTÕES PARA COLUNA VEICULO
          vetor[index].botao_con_cadastrar = {
            status: '',
            texto: (this.conGerTabVerificarFornecedorCliente(vetor[index]) === 'compra' ? 'Comprar' : 'Vender'),
            class: [ 'btn', 'btn-info', 'btn-sm' ],
            mostrar: true,
            onClick: this.conGerTabBotaoAcao
          }
          vetor[index].botao_con_qtde = {
            status: '',
            texto: '0',
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: true,
            onClick: this.conGerTabBotaoAcao
          }

          // VERIFICA O VALOR QUE DEVE PREENCHER
          if (this.conGerTabVerificarFornecedorCliente(vetor[index]) === 'compra') {
            vetor[index].botao_con_qtde.texto = ([ '', null, undefined ].indexOf(vetor[index].virtual_demanda_compra_total_qtde) !== -1 ? 0 : vetor[index].virtual_demanda_compra_total_qtde).toString()
          } else {
            vetor[index].botao_con_qtde.texto = ([ '', null, undefined ].indexOf(vetor[index].virtual_demanda_venda_total_qtde) !== -1 ? 0 : vetor[index].virtual_demanda_venda_total_qtde).toString()
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conGerTabReativar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente reativar o(s) contato(s) selecionados?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoReativar = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contato/reativar', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // MANDA ATUALIZAR A TABELA
                this.conGerTabBuscarLinhas()
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoReativar = this.conGerTabReativar

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.conGerTabSetarStatusGeral)
        }
      },
      conGerTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (this.checkbox.length >= 2) {
          this.$store.state.msgWarn('WEB [406]: Só é possivel editar um contato de cada vez.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'contato_form', params: { id: ids } })
        }
      },
      conGerTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) contato(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contato', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR A TABELA
                this.conGerTabBuscarLinhas()
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.conGerTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.conGerTabSetarStatusGeral)
        }
      },
      conGerTabVerificarFornecedorCliente: function (linha) {
        return [ '2' ].indexOf(linha.id_tp_con) !== -1 ? 'compra' : 'venda'
      },
      conGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [ { slot: 'contato',  group: 'Contato' } ]

        // VERIFICA SE TEM O PACOTE COMISSOES
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, [ 51 ], null, null, null, false) === true) {
          vetor.options.push({ slot: 'vendedor', group: 'Clientes do Vendedor', mask: 'id_cms', nome: 'Vendedor com ' })
        }

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      conGerTabOnBuscarOptionsFiltroO: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      conGerTabOnBuscarOptionsFiltroV: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== 'contato_form' && routeAtual.name !== 'contato_form') {
          // SETA O STATUS DA PAGINA
          this.conGerTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.conGerTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
